<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="$router.currentRoute.path == '/shop/customers'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <v-row>
          <v-col>
            <h5 class="m-0 pt-1">مدیریت مشتری‌ها</h5>
          </v-col>
          <v-col>
            <v-btn style="float: left" @click="showNewCustomerDialog()">
              ثبت جدید +
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0">
            <v-col cols="3" class="pb-0 mt-3"> </v-col>
            <v-col cols="6" class="pb-0 mt-3">
              <v-text-field
                v-model="userInput"
                placeholder="جستجو"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="3" class="pb-0 mt-3 text-left">
              <b-btn
                :disabled="userInput == ''"
                style="background-color: #aeb6bf !important"
                @click="delFilter()"
              >
                حذف فیلتر
              </b-btn>
            </v-col>
          </v-row>
        </template>
        <b-table
          responsive
          show-empty
          :items="customers"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="userInput"
          id="customers-tabel"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <router-link
                class="btn btn-success mr-1"
                :to="'/shop/customer/' + data.item.id"
                >پروفایل</router-link
              >
              <b-btn
                class="mr-1"
                variant="primary"
                @click="showCustomerDialog(data.item.id)"
                >ویرایش</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="customers-tabel"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>

    <v-dialog v-model="customerDialog" max-width="600px">
      <v-card style="overflow-y: scroll" height="80vh">
        <v-card-title>
          <h4>ویرایش مشتری</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام مشتری*"
              :loading="loading"
              v-model="customer.name"
            ></v-text-field>
            <v-select
              label="نوع مشتری*"
              :items="customerTypes"
              v-model="customer.type"
              :loading="loading"
              outlined
              dense
            />
            <v-text-field
              outlined
              dense
              label="موبایل"
              :loading="loading"
              v-model="customer.mobile"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="ایمیل"
              :loading="loading"
              v-model="customer.email"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="کد اقتصادی"
              :loading="loading"
              v-model="customer.economicCode"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="تلفن"
              :loading="loading"
              v-model="customer.phone"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="آدرس"
              :loading="loading"
              v-model="customer.address"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="کد ملی"
              :loading="loading"
              v-model="customer.natCode"
            ></v-text-field>

            <!-- <v-text-field
              outlined
              dense
              label="تراز مالی"
              disabled
              :loading="loading"
              v-model="customer.balance"
            ></v-text-field> -->
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="customerDialog = false">
            لغو
          </v-btn>
          <v-btn :loading="loading" color="primary" @click="editCustomer()">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newCustomerDialog" max-width="600px">
      <v-card style="overflow-y: scroll" height="80vh">
        <v-card-title>
          <h4>ثبت مشتری جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام مشتری*"
              :loading="loading"
              v-model="newCustomer.name"
            ></v-text-field>
            <v-select
              label="نوع مشتری*"
              :items="customerTypes"
              v-model="newCustomer.type"
              :loading="loading"
              outlined
              dense
            />
            <v-text-field
              outlined
              dense
              label="موبایل"
              :loading="loading"
              v-model="newCustomer.mobile"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="ایمیل"
              :loading="loading"
              v-model="newCustomer.email"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="کد اقتصادی"
              :loading="loading"
              v-model="newCustomer.economicCode"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="تلفن"
              :loading="loading"
              v-model="newCustomer.phone"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="آدرس"
              :loading="loading"
              v-model="newCustomer.address"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="کد ملی"
              :loading="loading"
              v-model="newCustomer.natCode"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newCustomerDialog = false"
          >
            لغو
          </v-btn>
          <v-btn
            :disabled="!newCustomer.name || !newCustomer.type"
            color="primary"
            @click="addCustomer()"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import router from "../../router";

export default {
  data: function () {
    return {
      guide: false,

      fields: [
        { key: "index", label: "ردیف" },
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "type", label: "نوع مشتری" },
        { key: "mobile", label: "موبایل سازمانی" },
        { key: "operation", label: "عملیات" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      TotalRows: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      filter: null,
      customers: [],
      selected: "",
      newCustomerDialog: false,
      newCustomer: {},
      loading: false,
      customer: {},
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    delFilter() {
      // this.sortBy = "";
      this.userInput = "";
      // this.isBusy = true;
      // this.showCustomers();
    },
    showNewCustomerDialog() {
      this.newCustomerDialog = true;
    },
    addCustomer() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/new",
        {
          name: this.newCustomer.name,
          mobile: this.newCustomer.mobile,
          email: this.newCustomer.email,
          economicCode: this.newCustomer.economicCode,
          phone: this.newCustomer.phone,
          address: this.newCustomer.address,
          natCode: this.newCustomer.natCode,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    editCustomer() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/edit",
        {
          shopCustomerId: this.selected,
          name: this.customer.name,
          mobile: this.customer.mobile,
          email: this.customer.email,
          economicCode: this.customer.economicCode,
          phone: this.customer.phone,
          address: this.customer.address,
          natCode: this.customer.natCode,
          type: this.customer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.isBusy = true;
            this.customerName = "";
            this.customerPriority = "";
            this.customerEmail = "";
            this.customerMobile = "";
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          console.log(res.data.name);
          if (res.status == 200) {
            this.customer.name = res.data.name;
            this.customer.mobile = res.data.mobile;
            this.customer.email = res.data.email;
            this.customer.economicCode = res.data.economicCode;
            this.customer.phone = res.data.phone;
            this.customer.address = res.data.address;
            this.customer.natCode = res.data.natCode;
            this.customer.type = res.data.type;
            this.customer.balance = res.data.balance;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showCustomerDialog(customer) {
      this.customerDialog = true;
      this.customerName = "";
      this.selected = customer;
      this.getCustomerInfo();
    },
    showCustomers() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
            this.TotalRows = this.customers.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
  },

  mounted() {
    this.showCustomers();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
